import { CIcon } from '~/icons/types'

export const ciAngleRight: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M15.53 11.47a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 1 1-1.06-1.06L13.94 12 9.47 7.53a.75.75 0 0 1 1.06-1.06l5 5Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'angle-right',
  type: 'light'
}
